export enum DataTableNamesEnum {
  CASE_DATATABLE = 'CaseDataTable',
  PROBLEM_RECORD_DATATABLE = 'ProblemRecordDataTable',
  KNOWLEDGE_LIBRARY_DATATABLE = "KnowledgeLibraryDataTable",
  SEARCH_CASE_DATATABLE = 'SearchCaseDataTable',
  SEARCH_PROBLEM_RECORD_DATATABLE = 'SearchProblemRecordDataTable',
  SEARCH_KNOWLEDGE_LIBRARY_DATATABLE = "SearchKnowledgeLibraryDataTable",
  DOCUMENT_LIBRARY_DATATABLE = "DocumentLibraryDataTable",
  IMPERSONATE_USER_DATATABLE = "ImpersonateUserDataTable",
}

export enum MultipleSelectionOptionsTypeEnum {
  CaseDataTable = '',
  KnowledgeLibraryDataTable = 'Knowledge',
  SearchCaseDataTable = 'Case',
  SearchKnowledgeLibraryDataTable = 'Knowledge'
}